import React, {ReactNode} from 'react';

import staticURL from 'lib/staticURL';

function BaseEnterpriseFeature({children, imageURL}: {children: ReactNode; imageURL: string}): JSX.Element {
  return (
    <div>
      <div className="legacy-font-proxima-15 u-moderate-spacing-bottom">{children}</div>
      <img className="referralModal-image" src={imageURL} />
    </div>
  );
}

export function Registry(): JSX.Element {
  return (
    <BaseEnterpriseFeature imageURL={staticURL('/static/img/enterprise/registry.png')}>
      The first registration system built from the ground up for biologics. It's flexible enough to model the
      biological entities of any organization, while making it easy for scientists to enter and extract the
      data they need.
    </BaseEnterpriseFeature>
  );
}

export function Workflows(): JSX.Element {
  return (
    <BaseEnterpriseFeature imageURL={staticURL('/static/img/enterprise/workflow.png')}>
      Structure processes from discovery to bioprocessing to track progress, eliminate bottlenecks, and power
      better research decisions.
    </BaseEnterpriseFeature>
  );
}

export function Requests(): JSX.Element {
  return (
    <BaseEnterpriseFeature imageURL={staticURL('/static/img/features/enterprise/requests-header.png')}>
      Request Management streamlines every step of the request fulfillment process — from scheduling and
      documentation to tracking and reporting — and enables teams to manage resource allocation in real-time.
    </BaseEnterpriseFeature>
  );
}

export function Reviews(): JSX.Element {
  return (
    <BaseEnterpriseFeature imageURL={staticURL('/static/img/enterprise/reviews.png')}>
      Sign off on Lab Notebook entries in compliance with 21 CFR Part 11. File for IND smoothly with
      comprehensive records.
    </BaseEnterpriseFeature>
  );
}

export function BulkMolecularBiology(): JSX.Element {
  return (
    <BaseEnterpriseFeature imageURL={staticURL('/static/img/enterprise/bulk_assembly.png')}>
      Assemble constructs, design guide RNAs for CRISPR, and translate sequences all in bulk. Eliminate time
      spent on repetitious molecular biology work.
    </BaseEnterpriseFeature>
  );
}

export function SampleTracking(): JSX.Element {
  return (
    <BaseEnterpriseFeature imageURL={staticURL('/static/img/enterprise/sample_tracking.png')}>
      Add a digital layer to the physical lab. Track functional data and locations at the level of individual
      containers, and link them to other registered entities.
    </BaseEnterpriseFeature>
  );
}
